export enum PAYMENT_TYPES {
  MERCADOPAGO = "mercadopago",
  MOBBEX = "mobbex",
}
